require('./bootstrap');

import Swal from 'sweetalert2'
import Pikaday from 'pikaday'
import './livewire/disable-pagination-links-form-submit';

window.copyToClipboard = (alertContent, content) => {
    navigator.clipboard.writeText(content);
}

window.Swal = Swal;
window.Pikaday = Pikaday;
window.akaScrollTop = () => {
    window.scrollTo({top: 0, behavior: 'smooth'})
}
